import { 
	REQUESTING,
	RECIPE
} from '../constants';
import {checkForwardMatch} from '../logics/utility';

const initialState = {
	content:{
		show:false,
	},
	fetchingState:REQUESTING.NONE,
	error:null,
};

export default function recipeReducer(state = initialState, action) {
	
	if(!checkForwardMatch(action.type,RECIPE.PREFIX)){
		return state;
	}
	
	switch (action.type) {
	case RECIPE.CLOSE_QUIZ:
	{
		return {
			...state,
			content:initialState.content
		};
	}
	case RECIPE.READ_QUIZ:
	{
		return {
			...state,
			content:Object.assign({},action.payload.content)
		};
	}
	default:
		return state;
	}
}